import React from 'react'
import Icon from './Icon'

function UserTieIcon(props) {
  return <Icon solid label="user-tie" {...props} />
}

export default UserTieIcon;
